import { render, staticRenderFns } from "./SpacesPopup.vue?vue&type=template&id=db6a8272"
import script from "./SpacesPopup.vue?vue&type=script&lang=js"
export * from "./SpacesPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports